<script>
function getHospitalId() {
  return sessionStorage.getItem("hospitalId");
}
export default {
  getHospitalId
};
</script>


// WEBPACK FOOTER //
// src/components/common/Common.vue